import type {ScanContext} from "../../scan-model/ScanContext.tsx";
import type {VersionScanPlan} from "../2-ScanVersions.tsx";
import type {OrchestrationJob} from "../../../../metl-models/jobs/Orchestration.ts";
import type {TransformationJob} from "../../../../metl-models/jobs/Transformation.ts";
import {runPromises} from "../../../../util/promises/PromiseRunner.tsx";
import type {ScannedJobResult} from "./scanJobDetails.ts";

export type JobTypeString = "TRANSFORMATION" | "ORCHESTRATION"
type DoScanDetails = (ctx: ScanContext, jobDebug: OrchestrationJob | TransformationJob, jobType: JobTypeString, jobName: string) => ScannedJobResult

export async function downloadJobsIndividually(ctx: ScanContext, versionScan: VersionScanPlan, doScanDetails: DoScanDetails) {
    const {startAction, options} = ctx
    const {reportOne, complete} = startAction(`Scanning jobs in ${versionScan.id.groupName}/${versionScan.id.projectName}/${versionScan.id.versionName}`, versionScan.jobCount)

    async function scan({job, jobType}: {job: string, jobType: JobTypeString}) {
        const jobDebug = await versionScan.api.jobs.get(job).debug()
        const result = doScanDetails(ctx, jobDebug, jobType, job)
        reportOne()
        return result
    }
    try {
        const items: {job: string, jobType: JobTypeString}[] = [
            ...versionScan.orchestrationJobs.map(x => ({job: x, jobType: "ORCHESTRATION" as JobTypeString})),
            ...versionScan.transformationJobs.map(x => ({job: x, jobType: "TRANSFORMATION" as JobTypeString}))
        ]
        return await runPromises(options.jobDownloadRunner, items, scan)
    } finally {
        complete()
    }
}

export async function downloadJobsExport(ctx: ScanContext, versionScan: VersionScanPlan, doScanDetails: DoScanDetails) {
    const api = ctx.api.project(versionScan.id).versions.get(versionScan.id.versionName).jobs
    const jobExports = await api.exportAll()
    return jobExports.objects.map((jobExport) => {
        const jobDebug = jobExport.jobObject
        return doScanDetails(ctx, jobDebug, jobExport.info.type, jobExport.info.name)
    })
}